@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

$lab-content-padding: 60px;
$lab-image-height: 157px;

a[data-section="design lab"],
a[data-section="explore templates"] {
  font-family: SharpSans, Sharp Sans, Helvetica, Arial, "Trebuchet MS", sans-serif;
  border-radius: 6px;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: none;
  gap: $spacing-8;
  padding: 0 $spacing-16;
  font-size: $typography-button-large-size;
  line-height: $typography-line-height;
}
a[data-section="design lab"] {
  border: 1px solid $color-blue-default;
  background: $color-blue-default;
  color: $color-shade-white;
  min-width: 205px;
  @media screen and (min-width: 1300px) {
    min-width: 210px;
  }
  &:link, &:visited {
    color: $color-shade-white;
  }
  &:hover {
    background: $color-blue-hover;
    border: 1px solid $color-blue-hover;
  }
}
a[data-section="explore templates"]{
  border: 1px solid $color-blue-default;
  color: $color-blue-default;

  &:hover {
    background-color: $color-blue-hover;
    color: $color-shade-white;
  }
}


.ciDesign {
  &-panel {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: $spacing-16;
    width: 100%;
    box-sizing: border-box;
    .ghf-primary-button, .ghf-secondary-button {
      box-sizing: border-box;
    }
  }
  &-lab {
    &-wrapper {
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      width: 100%;
      flex-wrap: nowrap;
    }
    &-heading {
      padding: 0;
      margin: 0 0 16px 0;
    }
    &-laptop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      height: 200px;
      width: 45%;
      @include image('assets/header/lab_laptop.png');
    }
    &-clipart {
      width: 55%;
    }

    &-content {
      width: 110%;
      margin-right: $lab-content-padding;
      @media screen and (max-width: 1299px) {
        width: 70%;
      }
      text-align: center;
      border-right: 1px solid #333;
      &-columns {
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 0 $lab-content-padding 0 0;
        margin: 16px 30px 0;
        @media screen and (max-width: 1299px) {
          margin-left: 0;
          padding-right: 30px;
        }
        width: 100%;
        box-sizing: border-box;
      }

      &-description {
        font-size: $typography-body-long2-size;
        line-height: $typography-line-height;
        width: 500px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 0;
      }
    }

    &-button {
      display: flex;
      justify-content: center;
      padding-top: 16px;
      /* a { */
      /*   min-width: 205px; */
      /*   @media screen and (min-width: 1300px) { */
      /*     min-width: 210px; */
      /*   } */
      /* } */
    }
  }
  &-inspiration-content {
    width: 31%;
    padding-right: $lab-content-padding;
    text-align: center;
    &-copy {
      margin-top: 0;
      font-size: $typography-body-long2-size;
      line-height: $typography-line-height;
    }
    &-image {
      background-position: center;
      background-repeat: no-repeat;
      background-color: white;
      background-size: cover;
      border-radius: 6px;
      height: $lab-image-height;
      width: 100%;
      margin-bottom: 16px;
      @include image('assets/header/inspiration.jpg');
    }
  }

  &-images {
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-size: $typography-caption-caption-regular-size;
    min-height: $lab-image-height;
    img {
      margin-top: 10px;
      margin-bottom: 5px;
      height: 90px;
      width: auto;
    }
    .sb-MMPLab-listItem-text {
      font-weight: 700;
    }
  }
}

@include breakpoint('xl') {
  .ciDesign {
    &-lab {
      &-mega {
        width: 710px;
        padding-right: $spacing-32;
      }
    }
    &-images img {
      margin-top: 0;
      height: 110px;
      width: auto;
    }
  }
}
